<template>
  <div class="post-management">
    <!-- <h1>Post Management</h1> -->
    <!-- 搜尋與功能區 -->
    <div class="search-bar-top">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>

        <input
          type="text"
          placeholder="搜尋公告"
          v-model="searchQuery"
          @input="updateFilteredPosts"
        />
      </div>
    </div>

    <!-- 功能區 -->
    <div class="action-buttons">
      <button class="action-button active" @click="showAllPosts">
        顯示所有公告
      </button>
      <button class="action-button secondary" @click="filterPosts('飯店公告')">
        飯店公告
      </button>
      <button class="action-button secondary" @click="filterPosts('最新消息')">
        最新消息
      </button>
      <button class="action-button secondary" @click="filterPosts('住宿方案')">
        住宿方案
      </button>
      <button class="action-button secondary" @click="filterPosts('餐廳新訊')">
        餐廳新訊
      </button>
      <button class="action-button primary" @click="openAddModal">
        新增公告
      </button>
    </div>

    <!-- 表格 -->
    <table class="member-table">
      <thead>
        <tr>
          <th>公告編號</th>
          <th>標題</th>
          <th>內容</th>
          <th>類別</th>
          <th>開始時間</th>
          <th>結束時間</th>
          <!-- <th>圖片</th> -->
          <!-- <th>建立時間</th> -->
          <!-- <th>建立者</th> -->
          <th>上架狀態</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="post in paginatedPosts" :key="post.id">
          <td>{{ post.id }}</td>
          <td>{{ truncate(post.title, 12) }}</td>
          <td>{{ truncate(post.contents, 12) }}</td>
          <td>{{ post.category }}</td>
          <td>{{ formatDate(post.starttime) }}</td>
          <td>{{ formatDate(post.endtime) }}</td>

          <!-- <td>{{ post.image }}</td> -->
          <!-- <td>{{ formatDate(post.createdate) }}</td> -->
          <!-- <td>{{ post.creator }}</td> -->
          <td>
            <span :class="post.enabled ? 'status-posty' : 'status-postn'">
              {{ post.enabled ? "已上架" : "未上架" }}
            </span>
          </td>
          <!-- <td>{{ post.enabled ? "已上架" : "未上架" }}</td> -->
          <td>
            <button @click="editPost(post)" class="action-menu-edit">
              查看
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 編輯公告 -->
    <div v-if="showEditModal" class="edit-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2>公告詳細資料</h2>
        </div>

        <form @submit.prevent="saveEdit">
          <div class="form-group">
            <label>標題</label>
            <input v-model="editPostData.title" required />
          </div>
          <div class="form-group">
            <label>內容</label>
            <textarea v-model="editPostData.contents"></textarea>
          </div>
          <div class="form-group">
            <label>類別</label>
            <select v-model="editPostData.category" required>
              <option value="最新消息">最新消息</option>
              <option value="飯店公告">飯店公告</option>
              <option value="住宿方案">住宿方案</option>
              <option value="餐廳新訊">餐廳新訊</option>
            </select>
          </div>
          <div class="form-group">
            <label>開始時間</label>
            <input type="date" v-model="editPostData.starttime" required />
          </div>
          <div class="form-group">
            <label>結束時間</label>
            <input type="date" v-model="editPostData.endtime" required />
          </div>
          <div class="form-group">
            <label>是否上架</label>
            <select v-model="editPostData.enabled">
              <option :value="true">已上架</option>
              <option :value="false">未上架</option>
            </select>
          </div>
          <div class="form-group">
            <label>圖片名稱</label>
            <input type="file" @change="handleFileUpload" />
            <!-- 顯示圖片檔名 -->
            <p>檔案名稱: {{ editPostData.image }}</p>
            <!--<img
              :src="editPostData.image"
              alt="圖片"
              v-if="editPostData.image"
              style="max-width: 100%; height: auto"
            /> -->
          </div>
          <div class="form-group">
            <label>建立時間</label>
            <p>{{ formatDate(editPostData.createdate) }}</p>
          </div>
          <div class="form-group">
            <label>建立者</label>
            <input v-model="editPostData.creator" disabled />
          </div>
          <div class="modal-actions">
            <!-- 更新按鈕 -->
            <button type="submit" class="save-btn">更新</button>
            <!-- 刪除按鈕 -->
            <button
              type="button"
              class="delete-btn"
              @click="confirmDeletePost(editPostData.id)"
            >
              刪除
            </button>
            <!-- 關閉按鈕 -->
            <button type="button" class="cancel-btn" @click="closeEditModal">
              關閉
            </button>
          </div>
        </form>
      </div>

      <!-- 確認刪除對話框 -->
      <!-- <div v-if="showDeleteConfirm">
        <div>
          <h2>確認刪除公告</h2>
          <p>確認要刪除公告嗎?</p>
          <div>
            <button @click="deletePost">刪除</button>
            <button @click="closeDeleteConfirm">取消</button>
          </div>
        </div>
      </div>-->
    </div>

    <!-- 新增公告模態框 -->
    <div v-if="showAddModal" class="edit-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2>新增公告</h2>
        </div>

        <form @submit.prevent="saveNewPost">
          <div class="form-group">
            <label>標題</label>
            <input v-model="newPostData.title" required />
          </div>
          <div class="form-group">
            <label>內容</label>
            <textarea v-model="newPostData.contents"></textarea>
          </div>
          <div class="form-group">
            <label>類別</label>
            <select v-model="newPostData.category" required>
              <option value="最新消息">最新消息</option>
              <option value="飯店公告">飯店公告</option>
              <option value="住宿方案">住宿方案</option>
              <option value="餐廳新訊">餐廳新訊</option>
            </select>
          </div>
          <div class="form-group">
            <label>開始時間</label>
            <input type="date" v-model="newPostData.starttime" required />
          </div>
          <div class="form-group">
            <label>結束時間</label>
            <input type="date" v-model="newPostData.endtime" required />
          </div>
          <div class="form-group">
            <label>是否上架</label>
            <select v-model="newPostData.enabled">
              <option :value="true">已上架</option>
              <option :value="false">未上架</option>
            </select>
          </div>
          <div class="form-group">
            <label>圖片名稱</label>
            <input type="file" @change="handleFileUpload" />
            <!-- 顯示圖片檔名 -->
            <p>檔案名稱: {{ newPostData.image }}</p>
            <!--<img
              :src="newPostData.image"
              alt="圖片"
              v-if="newPostData.image"
              style="max-width: 100%; height: auto"
            /> -->
          </div>
          <div class="modal-actions">
            <!-- 保存按鈕 -->
            <button type="submit" class="save-btn">新增</button>
            <!-- 關閉按鈕 -->
            <button type="button" class="cancel-btn" @click="closeAddModal">
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- 分頁 -->
    <div class="pagination">
      <button class="page-btn" :disabled="!hasPreviousPage" @click="prevPage">
        « Previous
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        :class="['page-number', { active: page === currentPage }]"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
      <button class="page-btn" :disabled="!hasNextPage" @click="nextPage">
        Next »
      </button>
    </div>
  </div>
</template>

<script>
import postLogic from "@/assets/js/background/post.js";
// import axios from "axios";

export default {
  name: "PostManagement",
  mixins: [postLogic],
  // mounted() {
  //   this.fetchPosts();
  // },
};
</script>

<style src="@/assets/css/background/post.css" scoped></style>
